<template>
  <div class="content">
    <div class="content-label-group">
      <label class="text-value">{{ component.label }}</label>
    </div>
    <div class="content-group">
      <template
        ><RenderPreview
          v-for="field in component.fields"
          :key="field.name"
          :component="field"
        ></RenderPreview
      ></template>
      <template
        ><RenderPreview
          v-for="field in component.fields1"
          :key="field.name"
          :component="field"
        ></RenderPreview
      ></template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GroupField',

  components: {
    RenderPreview: () => import('./RenderPreview.vue'),
  },

  props: {
    component: {
      type: Object,
      required: true,
    },
  },

  data: () => ({}),
}
</script>
<style scoped>
.content {
  display: flex;
  flex-direction: column;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  margin: 5px;
}
.content-label-group {
  display: flex;
  padding: 20px;
  border-radius: 8px;
  background-color: #dddddd;
}
.content-group {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 10px;
}
.text-value {
  font-weight: bold;
  font-size: 14px;
  font-family: 'Rajdhani', sans-serif;
  color: #69739e;
  padding-left: 10px;
}
</style>
